// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1921":"e688898df3a03b0f","2888":"375a6752d8aa743a","7482":"e688898df3a03b0f","8625":"e688898df3a03b0f"}[chunkId] + ".css";
};